export default __webpack_public_path__ + "static/media/MVRDV-slide-05.8b1207cb.jpg";